<template>
    <div class="school-admin-schedule">
        <PreLoader v-if="isLoading" />
        <SuperAdminSchoolHead class="sash-main sas-head">
            <template v-slot:title>{{ $t('schedule')}}</template>
            <template v-slot:center>
                <div class="sas-head-center">
                    <v-select outlined dense :items="allShifts" item-text="name" item-value="id"
                              v-model="selectedShiftId" :label="$t('chooseShift')" @change="onSelectShift"/>
                    <router-link :to="{name: 'directorShifts'}">
                        <v-btn color="primary" v-text="$t('allShift')"/>
                    </router-link>
                </div>
            </template>
        </SuperAdminSchoolHead>
        <div class="schedule-content" v-if="shiftTimes.length" ref="schedule">
            <div class="other-actions justify-space-between">
                <div class="main-btn">
                    <div class="switch-filter">
                        <v-switch :label="$t('teacher') + `/` + $t('number')" v-model="classViewSchedule"/>
                    </div>
                    <div class="print-btn">
                        <v-btn color="primary" @click="downloadPdf" v-text="`${$t('download')} (PDF)`"/>
                    </div>
                </div>
                <v-pagination v-if="!classViewSchedule" v-model="currentPage"
                              :length="totalPages" :total-visible="10"/>
                <span v-if="!classViewSchedule" v-html="paginationPageText"/>
            </div>
            <FixedScheduleTableHeader ref="fixedTable" :days="days" :shiftTimes="shiftTimes" @scrollTable="scrollTable"
                                      :teacherLabelWidth="teacherLabelWidth" :courseLabelWidth="courseLabelWidth"
                                      :classLabelWidth="classLabelWidth" :classViewSchedule="classViewSchedule"
                                      :datesOfWeek="datesOfWeek" :showScrollArrows="showScrollArrows"/>
            <div class="teacher-course-tables" v-if="!classViewSchedule" ref="teacherTable">
                <table class="teachers">
                    <tbody>
                    <tr v-for="teacher in allTeachers" :key="teacher.id">
                        <td class="teacher-name" :class="{'same': !teacher.teacherName}" ref="teacherLabel">
                            <span v-if="teacher.teacherName" :class="{'space': teacher.several}"
                                  class="scl-ad_tab-txt teach-name" v-html="teacher.teacherName"/>
                            <span class="empty" v-else>-</span>
                        </td>
                        <td class="course-name" ref="courseLabel">
                            <div class="scl-ad_tab-txt scl-ad_tab-txt_course-name">
                                {{ teacher[langObj[currentLang]] === null
                                ? $t('notTranslate') : teacher[langObj[currentLang]]}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="schedule-teacher-course" ref="scheduleTable">
                    <tbody>
                    <tr v-for="teacher in allTeachers" :key="teacher.id">
                        <td class="days" v-for="(day, d) in days" :key="d">
                            <div class="classes">
                                <template v-for="(time) in shiftTimes">
                                    <span v-if="getSpecificSchedule(day.day, time.id, teacher).length" class="hasClass"
                                          :class="{'group-color': getSpecificSchedule(day.day, time.id, teacher).length > 1}">
                                     {{ getSpecificSchedule(day.day, time.id, teacher)[0].classTitle.replace(' ', '') }}
                                    </span>
                                    <span class="noClass" v-else/>
                                </template>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div class="class-schedule-tables teacher-course-tables" v-if="classViewSchedule" ref="classTable">
                <table class="class-name-table">
                    <tbody>
                    <tr v-for="klass in classes" :key="klass.id">
                        <td class="className teacher-name">
                            <span>{{klass.classLevel + ' ' + klass.classLabel}}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="class-courses-table" ref="scheduleTable">
                    <tbody>
                    <tr v-for="klass in classes" :key="klass.id">
                        <td class="days" v-for="(day, d) in days" :key="d">
                            <div class="classes">
                                <template v-for="time in shiftTimes">
                                    <span v-if="getSpecificCourseSchedule(day.day, time.id, klass)" class="courseCode">
                                        {{ getSpecificCourseSchedule(day.day, time.id, klass)[langObj[currentLang]].slice(0,4) }}
                                    </span>
                                    <span class="noClass" v-else/>
                                </template>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import ScheduleWeekService from '@/_services/schedule-week.service'
import ShiftService from '@/_services/shift.service'
import ShiftTimeService from '@/_services/shift-time.service'
import SchoolClassService from '@/_services/school-class.service'
import { InstructorCourseService } from '@/_services/instructor-course.service'
import PreLoader from '@/components/preloader/PreLoader'
import FixedScheduleTableHeader from '@/components/table/FixedScheduleTableHeader'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
const instructorCourseService = new InstructorCourseService()
pdfMake.vfs = pdfFonts['pdfMake'].vfs

export default {
    components: {SuperAdminSchoolHead, PreLoader, FixedScheduleTableHeader},
    data () {
        return {
            isLoading: false,
            required: [v => !!v || this.$t('fieldIsRequired')],
            sendScheduleObj: {
                chronicleId: 0,
                classId: 0,
                courseId: 0,
                instructorId: 0,
                shiftTimeId: 0,
                weekDay: '',
                groupTitle: '',
                grouped: false,
                archived: false,
                instrCourseId: ''
            },
            langObj: {ru: 'courseTitle', kg: 'courseTitleKG', en: 'courseCode'},
            objDay: {
                MONDAY: this.$t('monday'),
                TUESDAY: this.$t('tuesday'),
                WEDNESDAY: this.$t('wednesday'),
                THURSDAY: this.$t('thursday'),
                FRIDAY: this.$t('friday'),
                SATURDAY: this.$t('saturday')
            },
            objNumDays: {
                1: 'MONDAY',
                2: 'TUESDAY',
                3: 'WEDNESDAY',
                4: 'THURSDAY',
                5: 'FRIDAY',
                6: 'SATURDAY'
            },
            totalElements: 0,
            size: 20,
            pageSize: 0,
            currentPage: 1,
            totalPages: 0,
            days: [
                { day: 'MONDAY', name: this.$t('monday') },
                { day: 'TUESDAY', name: this.$t('tuesday') },
                { day: 'WEDNESDAY', name: this.$t('wednesday') },
                { day: 'THURSDAY', name: this.$t('thursday') },
                { day: 'FRIDAY', name: this.$t('friday') },
                { day: 'SATURDAY', name: this.$t('saturday') }
            ],
            mode: '',
            classViewSchedule: false,
            showAddGroup: false,
            originGrouped: false,
            showFixedHeader: false,
            showScrollArrows: true,
            manualScroll: true,
            currentShiftId: '',
            selectedShiftTime: {},
            classes: [],
            allSchedules: [],
            allShifts: [],
            shiftTimes: [],
            allTeachers: [],
            groupedSchedules: [],
            teacherLabelWidth: 0,
            courseLabelWidth: 0,
            classLabelWidth: 0,
            datesOfWeek: [],
            selectedShiftId: 0
        }
    },
    watch: {
        currentPage (val) {
            if (val === 0) this.getAllSchoolInstructors(val)
            else this.getAllSchoolInstructors(val - 1)
        }
    },
    mounted () {
        this.days = [
            { day: 'MONDAY', name: this.$t('monday') },
            { day: 'TUESDAY', name: this.$t('tuesday') },
            { day: 'WEDNESDAY', name: this.$t('wednesday') },
            { day: 'THURSDAY', name: this.$t('thursday') },
            { day: 'FRIDAY', name: this.$t('friday') },
            { day: 'SATURDAY', name: this.$t('saturday') }
        ]
    },
    computed: {
        userProfile () {
            return this.$store.state.account.profile
        },
        school () {
            return this.userProfile.schools[0]
        },
        currentLang () {
            return this.$root.$i18n.locale
        },
        totalPage () {
            return this.totalPages
        },
        paginationPageText () {
            return this.$t('paginationPageText', [this.totalElements, this.currentPage, this.totalPages])
        }
    },
    created () {
        this.isLoading = true
        this.getDatesOfWeek()
        this.getAllSchoolInstructors(0)
        this.getAllSchoolShifts()
    },
    beforeDestroy () {
        if (this.$refs.scheduleTable) {
            this.$refs.scheduleTable.removeEventListener('scroll', this.horizontalScheduleScrollListener)
        }
    },
    methods: {
        async onSelectShift (shiftId) {
            this.isLoading = true
            this.currentShiftId = shiftId
            await this.getAllSchoolClasses()
            await this.getShiftTimesByShiftId()
            await this.fetchScheduleData()
        },
        getDatesOfWeek () {
            ScheduleWeekService.getDatesOfWeek().then((res) => {
                if (res.length) this.datesOfWeek = res
                else this.isLoading = false
            }).catch(err => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        getAllSchoolInstructors (page) {
            this.allTeachers.length = 0
            instructorCourseService.getAllWithoutPagination(this.school.id, page, 20, '')
                .then((res) => {
                    if (res.content.length) {
                        Object.entries(res.content
                            .map((item, index) => ({ ...item, id: index + 1 })).reduce((obj, el) => {
                                obj[el.instructorId] = [...obj[el.instructorId] || [], el]
                                return obj
                            }, {}))
                            .forEach((item) => {
                                item[1][0].teacherName = item[1][0]['instructorTitle']
                                item[1][0].several = item[1].length > 1
                                item[1].forEach((instrCourse) => this.allTeachers.push(instrCourse))
                            })
                        this.allTeachers.sort(
                            (a, b) => a['instructorTitle'].localeCompare(b['instructorTitle'])
                        )
                        this.$nextTick(() => {
                            setTimeout(() => {
                                if (this.$refs.scheduleTable) {
                                    this.$refs.scheduleTable.addEventListener(
                                        'scroll', this.horizontalScheduleScrollListener
                                    )
                                    this.showScrollArrows = this.$refs.scheduleTable.scrollWidth
                                        > this.$refs.scheduleTable.clientWidth
                                    if (!this.classViewSchedule) {
                                        this.teacherLabelWidth = this.$refs.teacherLabel[0]
                                            ? this.$refs.teacherLabel[0].offsetWidth : '100'
                                        this.courseLabelWidth = this.$refs.courseLabel[0].offsetWidth
                                    } else this.classLabelWidth = this.$refs.classLabel[0].offsetWidth
                                }
                                this.isLoading = false
                            }, 20)
                        })
                    }
                    this.totalElements = res.totalElements
                    this.pageSize = res.pageSize
                    this.totalPages = res.totalPages
                })
                .catch(err => {
                    this.$toast.error(err)
                    this.isLoading = false
                })
        },
        fetchScheduleData () {
            this.allSchedules = []
            ScheduleWeekService.getAllBySchoolAndShift(this.school.id, this.currentShiftId).then((res) => {
                this.allSchedules = res.map((schedule) => {
                    schedule.weekDay = this.objNumDays[schedule.weekDay]
                    return schedule
                })
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.$refs.scheduleTable) {
                            this.$refs.scheduleTable.addEventListener(
                                'scroll', this.horizontalScheduleScrollListener
                            )
                            this.showScrollArrows = this.$refs.scheduleTable.scrollWidth
                                > this.$refs.scheduleTable.clientWidth
                            if (!this.classViewSchedule) {
                                this.teacherLabelWidth = this.$refs.teacherLabel
                                    ? this.$refs.teacherLabel[0].offsetWidth : 100
                                this.courseLabelWidth = this.$refs.courseLabel
                                    ? this.$refs.courseLabel[0].offsetWidth : 100
                            } else this.classLabelWidth = this.$refs.classLabel[0].offsetWidth
                        }
                        this.isLoading = false
                    }, 20)
                })
            }).catch(err => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        getAllSchoolShifts () {
            ShiftService.getAllBySchool(this.school.id).then((res) => {
                this.allShifts = res
                if (res.length) {
                    this.selectedShiftId = res[0].id
                    this.onSelectShift(this.selectedShiftId)
                } else this.isLoading = false
            }).catch((err) => {
                this.$toast.error(err)
                this.isLoading = false
            })
        },
        getAllSchoolClasses () {
            SchoolClassService.getAllBySchool(this.school.id).then((res) => {
                this.classes = res.map((klass) => {
                    klass.classTitle = klass.classLevel + klass.classLabel
                    return klass
                })
            }).catch(err => this.$toast.error(err))
        },
        getShiftTimesByShiftId () {
            ShiftTimeService.getAllByShiftId(this.currentShiftId)
                .then((res) => this.shiftTimes = res.sort((a, b) => a.name - b.name))
                .catch(err => this.$toast.error(err))
        },
        getSpecificSchedule (day, timeId, teacher) {
            return this.allSchedules.filter(schedule =>
                schedule.weekDay === day &&
                schedule.shiftTimeId === timeId &&
                schedule.instructorId === teacher.instructorId &&
                schedule.courseId === teacher.courseId
            )
        },
        scrollTable (nav) {
            this.manualScroll = false
            const scheduleTable = this.$refs.scheduleTable
            const fixedHeadTable = this.$refs.fixedTable.$refs.fixedHead
            if (nav === 'right') {
                scheduleTable.scrollLeft = scheduleTable.scrollWidth - scheduleTable.clientWidth
                fixedHeadTable.scrollLeft = scheduleTable.scrollWidth - scheduleTable.clientWidth
            } else {
                scheduleTable.scrollLeft = 0
                fixedHeadTable.scrollLeft = 0
            }
            setTimeout(() => this.manualScroll = true, 450)
        },
        horizontalScheduleScrollListener () {
            if (this.manualScroll) {
                const fixedTableHeader = this.$refs.fixedTable.$refs.fixedHead
                fixedTableHeader.scrollLeft = this.$refs.scheduleTable.scrollLeft
            }
        },

        // Filter by class functions
        getSpecificCourseSchedule (day, timeId, klass) {
            return this.allSchedules.find((schedule) =>
                schedule.weekDay === day &&
                schedule.shiftTimeId === timeId &&
                schedule.classId === klass.id
            )
        },
        downloadPdf () {
            if (this.classViewSchedule) this.downloadClassSchedulePdf()
            else this.downloadTeacherSchedulePdf()
        },
        downloadTeacherSchedulePdf () {
            this.isLoading = true
            const width = this.shiftTimes.map(() => 12)
            const exportScheduleData = []
            this.allTeachers.forEach((teacher) => {
                const currentScheduleArr = []
                currentScheduleArr.push({ text: teacher['instructorTitle'], style: 'general' })
                currentScheduleArr.push({ text: teacher[this.langObj[this.currentLang]], style: 'general' })
                this.days.forEach((day) => {
                    const daySchedules = []
                    this.shiftTimes.forEach((time) => {
                        const schedules = this.getSpecificSchedule(day.day, time.id, teacher)
                        const foundSchedule = schedules.length ? schedules[0].classTitle : ''
                        daySchedules.push({
                            text: foundSchedule,
                            style: 'general',
                            border: [false, false, true, false]
                        })
                    })
                    currentScheduleArr.push([{
                        table: {
                            widths: width,
                            body: [daySchedules]
                        }
                    }])
                })
                exportScheduleData.push(currentScheduleArr)
            })
            const docDefinition = {
                header: [{ text: `Недельное расписание школы ${this.school.nameRu}`, style: 'headTitle' }],
                pageOrientation: 'landscape',
                pageSize: 'A3',
                permissions: {
                    printing: 'highResolution',
                    modifying: false,
                    copying: false,
                    annotating: true,
                    fillingForms: true,
                    contentAccessibility: true,
                    documentAssembly: true
                },
                content: [{
                    table: {
                        headerRows: 2,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: [
                            [
                                '',
                                '',
                                { text: 'Понедельник', style: 'general' },
                                { text: 'Вторник', style: 'general' },
                                { text: 'Среда', style: 'general' },
                                { text: 'Четверг', style: 'general' },
                                { text: 'Пятница', style: 'general' },
                                { text: 'Суббота', style: 'general' }
                            ],
                            [
                                { text: 'Учитель', style: 'general' },
                                { text: 'Предмет', style: 'general' },
                                this.exportShiftTimes(12),
                                this.exportShiftTimes(12),
                                this.exportShiftTimes(12),
                                this.exportShiftTimes(12),
                                this.exportShiftTimes(12),
                                this.exportShiftTimes(12)
                            ]
                        ]
                    }
                }],
                styles: {
                    general: {fontSize: 7, alignment: 'center', margin: [0, 0, 0, 0]},
                    headTitle: {alignment: 'center', bold: true, fontSize: 13, margin: [0, 10, 0, 0]}
                }
            }
            docDefinition.content[0].table.body = [...docDefinition.content[0].table.body, ...exportScheduleData]
            setTimeout(() => {
                pdfMake.createPdf(docDefinition).download(`Расписание школы ${this.school.nameRu}.pdf`)
                setTimeout(() => this.isLoading = false, 50)
            }, 100)
        },
        downloadClassSchedulePdf () {
            this.isLoading = true
            const width = this.shiftTimes.map(() => 16)
            const exportScheduleData = []
            this.classes.forEach((klass) => {
                const currentScheduleArr = []
                currentScheduleArr.push({ text: klass.classLevel + klass.classLabel, style: 'general' })
                this.days.forEach((day) => {
                    const daySchedules = []
                    this.shiftTimes.forEach((time) => {
                        const schedule = this.getSpecificCourseSchedule(day.day, time.id, klass)
                        const foundSchedule = schedule ? schedule[this.langObj[this.currentLang]].slice(0, 3) : ''
                        daySchedules.push({
                            text: foundSchedule,
                            style: 'general',
                            border: [false, false, true, false]
                        })
                    })
                    currentScheduleArr.push([{
                        table: {
                            widths: width,
                            body: [daySchedules]
                        }
                    }])
                })
                exportScheduleData.push(currentScheduleArr)
            })
            const docDefinition = {
                header: [{ text: `Недельное расписание школы ${this.school.nameRu}`, style: 'headTitle' }],
                pageOrientation: 'landscape',
                pageSize: 'A3',
                permissions: {
                    printing: 'highResolution',
                    modifying: false,
                    copying: false,
                    annotating: true,
                    fillingForms: true,
                    contentAccessibility: true,
                    documentAssembly: true
                },
                content: [{
                    table: {
                        headerRows: 2,
                        widths: ['auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],
                        body: [
                            [
                                '',
                                { text: 'Понедельник', style: 'general' },
                                { text: 'Вторник', style: 'general' },
                                { text: 'Среда', style: 'general' },
                                { text: 'Четверг', style: 'general' },
                                { text: 'Пятница', style: 'general' },
                                { text: 'Суббота', style: 'general' }
                            ],
                            [
                                { text: 'Класс', style: 'general' },
                                this.exportShiftTimes(16),
                                this.exportShiftTimes(16),
                                this.exportShiftTimes(16),
                                this.exportShiftTimes(16),
                                this.exportShiftTimes(16),
                                this.exportShiftTimes(16)
                            ]
                        ]
                    }
                }],
                styles: {
                    general: {
                        fontSize: 7,
                        alignment: 'center',
                        margin: [0, 0, 0, 0]
                    },
                    headTitle: {
                        alignment: 'center',
                        bold: true,
                        fontSize: 13,
                        margin: [0, 10, 0, 0]
                    }
                }
            }
            docDefinition.content[0].table.body = [...docDefinition.content[0].table.body, ...exportScheduleData]
            setTimeout(() => {
                pdfMake.createPdf(docDefinition).download(`Расписание(класс-вид) школы ${this.school.nameRu}.pdf`)
                setTimeout(() => {
                    this.isLoading = false
                }, 50)
            }, 100)
        },
        exportShiftTimes (num) {
            const data = []
            const width = this.shiftTimes.map(() => num)
            this.shiftTimes.forEach((time) => {
                data.push({ text: time.name, style: 'general', border: [false, false, true, false] })
            })
            return [{
                table: {
                    widths: width,
                    body: [data]
                }
            }]
        }
    }
}
</script>

<style lang="scss">
th{
    vertical-align: middle;
}
td, tr{
    vertical-align: middle!important;
}
    body {
        scroll-behavior: smooth;
    }
    .school-admin-schedule {
        .shift-actions {
            display: flex;
            align-items: center;
            .select-shift {
                margin-right: 30px;
            }
        }
        .schedule-content {
            margin: 27px;
            .other-actions {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 15px;
                .main-btn {
                    display: flex;
                    align-items: center;
                }
            }
            .teacher-course-tables {
                display: flex;
                align-items: center;
                justify-content: center;
                table.teachers, table.class-name-table {
                    background: #fff;
                    border-bottom: 1px solid rgba(#707070, 0.8);
                    tr {
                        th {
                            border: 1px solid rgba(#707070, 0.8);
                            height: 49px;
                            min-width: 49px;
                            max-width: 49px;
                            width: 49px;
                            text-align: center;
                            color: #5e5e5e;
                        }
                        td {
                            border-top: 1px solid rgba(#707070, 0.8);
                            border-left: 1px solid rgba(#707070, 0.8);
                            border-right: 1px solid rgba(#707070, 0.8);
                            font-size: 14px;
                            &.className {
                                min-width: 49px;
                            }
                            &.teacher-name {
                                text-align: center;
                                span {
                                    display: inline-block;
                                    padding: 5px 8px;
                                    white-space: nowrap;
                                    height: 30px;
                                    &.space {
                                        transform: translateY(15px);
                                    }
                                    &.empty {
                                        color: transparent;
                                    }
                                }
                            }
                            &.course-name {
                                padding: 0 8px;
                                white-space: nowrap;
                                text-align: center;
                            }
                            &.same {
                                border-top-color: transparent;
                            }
                        }
                    }
                }
                table.schedule-teacher-course, table.class-courses-table {
                    border-top: 0;
                    border-left: 0;
                    border-bottom: 0;
                    max-width: 100%;
                    overflow-x: auto;
                    display: inline-block;
                    scroll-behavior: smooth;
                    background: #fff;
                    &::-webkit-scrollbar {
                        width: 0;
                        height: 0;
                        background: transparent;
                    }
                    &::-webkit-scrollbar-thumb {
                        background-color: rgba(0, 0, 0, 0.3)
                    }
                    tr {
                        th {
                            border: 1px solid rgba(#707070, 0.8);
                            border-right: 2px solid rgba(#707070, 0.8);
                            min-height: 49px;
                            .day {
                                text-align: center;
                                color: #5e5e5e;
                            }
                            .shiftTime {
                                display: flex;
                                span {
                                    display: inline-block;
                                    text-align: center;
                                    width: 32px;
                                    color: #5e5e5e;
                                    &:not(:last-child) {
                                        border-right: 1px solid rgba(#707070, 0.8);
                                    }
                                }
                            }
                        }
                        td {
                            border: 1px solid rgba(#707070, 0.8);
                            border-right: 2px solid rgba(#707070, 0.8);
                            &.days {
                                line-height: 0;
                                .classes {
                                    display: flex;
                                    span {
                                        display: flex;
                                        align-items: center;
                                        justify-content: center;
                                        width: 32px;
                                        height: 30px;
                                        font-size: 15px;
                                        cursor: pointer;
                                        &:not(:last-child) {
                                            border-right: 1px solid rgba(#707070, 0.8);
                                        }
                                        &.noCourse {
                                            cursor: default;
                                        }
                                        &.courseCode {
                                            font-size: 11px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .group-color {
                background: #009688;
                color: #fff;
            }
            .scroll-arrows {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-left: 70px;
                padding-top: 10px;
                .left {
                    transform: rotate(180deg) translateY(7px);
                }
            }
        }
        .export-title {
            display: none;
            text-align: center;
            margin: 20px 0 35px;
            text-transform: uppercase;
        }
        .print-btn {
            text-align: right;
            margin-left: 70px;
            .v-btn:not(.v-btn--round).v-size--default {
                height: 30px;
                padding: 0 10px;
            }
            .v-btn__content {
                font-size: 12px;
            }
        }
    }
</style>
